/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer';
import { CostRecordMetadataType } from '../models/CostRecordMetadataType';

/**
* Additional metadata specific to the metering dimension. The \'type\' field indicates which additional fields are populated: - DATA_TRANSFER: dataTransfer object is present 
*/
export class CostRecordMetadata {
  'type': CostRecordMetadataType;
  'dataTransfer'?: CostRecordMetadataDataTransfer;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "type",
      "baseName": "type",
      "type": "CostRecordMetadataType",
      "format": ""
    },
    {
      "name": "dataTransfer",
      "baseName": "dataTransfer",
      "type": "CostRecordMetadataDataTransfer",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostRecordMetadata.attributeTypeMap;
  }

  public constructor() {
  }
}



